// Static site data — easy to swap without touching component logic.

export const BRAND = {
  name: "Wen Jie Studio",
  tagline: "Design. Build. Launch.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_55709b5f-7c73-4c9e-b186-642b7db55695/artifacts/s4wuumsp_image.png",
  linkedin: "https://www.linkedin.com/in/wen-jie-teo-ba17312a7/",
  instagram: "https://www.instagram.com/wj_stud.io/",
  facebook: "https://www.facebook.com/teo.wenjie.1",
  email: "hello@wenjiestudio.com",
};

export const SERVICES = [
  {
    slug: "website-design",
    number: "01",
    title: "Website Design",
    description:
      "Distinctive brand websites engineered for clarity, speed, and quiet confidence. Built to convert without shouting.",
    features: ["Brand-led visuals", "Custom typography", "Responsive across devices"],
  },
  {
    slug: "landing-pages",
    number: "02",
    title: "Landing Pages",
    description:
      "Focused, high-intent pages for launches, funnels, and campaigns. Every pixel is earned.",
    features: ["Conversion-first layout", "A/B ready", "Motion refinements"],
  },
  {
    slug: "ui-ux",
    number: "03",
    title: "UI / UX Design",
    description:
      "Product interfaces that feel effortless. Interaction flows shaped around real user behaviour, not templates.",
    features: ["User research", "Design systems", "Prototype to production"],
  },
  {
    slug: "ai-products",
    number: "04",
    title: "AI-Assisted Products",
    description:
      "Thoughtful integrations of modern intelligence — where it earns its place in the interface, and never for its own sake.",
    features: ["Content workflows", "Assistive UX", "Model-agnostic"],
  },
  {
    slug: "automation",
    number: "05",
    title: "Automation-Ready Systems",
    description:
      "Websites wired to the tools that run your business. Fewer manual steps, more time spent on the work itself.",
    features: ["CRM & CMS", "Zapier / n8n flows", "Analytics baked in"],
  },
  {
    slug: "strategy",
    number: "06",
    title: "Business Website Strategy",
    description:
      "Clarity before pixels. Positioning, messaging, and information architecture that make design decisions obvious.",
    features: ["Positioning audit", "Sitemap & IA", "Content direction"],
  },
];

export const CONCEPT_PROJECTS = [
  {
    slug: "north-real-estate",
    label: "Studio Concept",
    category: "Real Estate Website",
    title: "North — Boutique real estate concept",
    objective:
      "Position luxury inventory through storytelling rather than listings and lead-forms.",
    approach:
      "Full-bleed cinematography, quiet numbers, private-by-request flows, and neighborhood editorial.",
    features: ["Cinematic hero", "Property gallery", "Private inquiry"],
    tech: ["Astro", "GSAP", "Cloudinary"],
    image:
      "https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgzNjMyODA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "atelier-modern-business",
    label: "Studio Concept",
    category: "Modern Business Website",
    title: "Atelier — A quiet business website concept",
    objective:
      "Reimagine the corporate website as a calm, editorial experience — trust through restraint.",
    approach:
      "Editorial grid, generous white space, subtle motion on scroll, and a hero anchored in typography.",
    features: ["Editorial hero", "Case study module", "Careers page pattern"],
    tech: ["Framer Motion", "Next.js", "MDX"],
    image:
      "https://images.unsplash.com/photo-1724906019868-93ad2c79414f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzNjMyODA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "lumen-saas-dashboard",
    label: "Studio Concept",
    category: "SaaS Dashboard",
    title: "Lumen — Analytics dashboard concept",
    objective:
      "Show how a data product can feel human — dense, but calm; expressive, without noise.",
    approach:
      "Charcoal canvas, single accent, micro-interactions on data cells, keyboard-first navigation.",
    features: ["Command palette", "Real-time charts", "Collaborative comments"],
    tech: ["React", "Recharts", "Tailwind"],
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRpZ2l0YWwlMjBhbmFseXRpY3MlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzgzNjMyODA2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "saison-restaurant",
    label: "Studio Concept",
    category: "Restaurant Website",
    title: "Saison — Fine-dining restaurant concept",
    objective:
      "Translate a chef’s intent into a website that behaves like a menu — patient, tactile, considered.",
    approach:
      "Serif accents, dish-first imagery, quiet booking flow, mobile-first with tactile hover states.",
    features: ["Tasting menu view", "Reservation flow", "Press & story"],
    tech: ["Next.js", "Sanity", "Framer Motion"],
    image:
      "https://images.unsplash.com/photo-1776993298456-98c71c0e177e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMG1vZGVybiUyMGludGVyaW9yfGVufDB8fHx8MTc4MzYzMjgwNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "arc-coach-consultant",
    label: "Studio Concept",
    category: "Coach & Consultant",
    title: "Arc — Executive coach concept",
    objective:
      "Give a solo practitioner a website that reads like a book’s inside flap — clear, singular, memorable.",
    approach:
      "Editorial spread, credibility built through case notes and long-form, minimal booking friction.",
    features: ["Booking module", "Long-form essays", "Testimonials pattern"],
    tech: ["Astro", "Cal.com", "MDX"],
    image:
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBidXNpbmVzcyUyMGNvYWNoJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4MzYzMjgwNnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "field-landing-suite",
    label: "Studio Concept",
    category: "Landing Page System",
    title: "Field — Launch landing suite concept",
    objective:
      "A modular landing system for startups shipping monthly — same voice, different pages, no drift.",
    approach:
      "Design tokens per campaign, shared motion library, analytics wired from day one.",
    features: ["Design tokens", "Reusable blocks", "Split testing"],
    tech: ["Next.js", "Vercel", "PostHog"],
    image:
      "https://images.unsplash.com/photo-1510519138101-570d1dca3d66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwZGFyayUyMGRpZ2l0YWwlMjB3b3Jrc3BhY2UlMjBkZXNrfGVufDB8fHx8MTc4MzYzMjgwNnww&ixlib=rb-4.1.0&q=85",
  },
];

export const PROCESS_STEPS = [
  {
    slug: "discover",
    number: "01",
    title: "Discover",
    body: "We start with your business, not your website. Positioning, audience, and the outcome that actually matters.",
  },
  {
    slug: "plan",
    number: "02",
    title: "Plan",
    body: "Sitemap, content direction, and a clear scope. No surprises later — the plan is the contract.",
  },
  {
    slug: "design",
    number: "03",
    title: "Design",
    body: "Typography, hierarchy, motion — designed to feel considered, quietly premium, unmistakably yours.",
  },
  {
    slug: "build",
    number: "04",
    title: "Build",
    body: "Fast, accessible, and wired to your stack. Everything a modern site should be, without the bloat.",
  },
  {
    slug: "launch",
    number: "05",
    title: "Launch",
    body: "We ship carefully — DNS, analytics, and a walkthrough so your team owns the site from day one.",
  },
  {
    slug: "improve",
    number: "06",
    title: "Improve",
    body: "The website is a product. We iterate — small refinements, new sections, better performance over time.",
  },
];

export const TOOLS = [
  { slug: "figma", name: "Figma" },
  { slug: "framer", name: "Framer" },
  { slug: "react", name: "React" },
  { slug: "nextjs", name: "Next.js" },
  { slug: "tailwind", name: "Tailwind" },
  { slug: "webflow", name: "Webflow" },
  { slug: "vercel", name: "Vercel" },
  { slug: "supabase", name: "Supabase" },
  { slug: "notion", name: "Notion" },
  { slug: "sanity", name: "Sanity" },
  { slug: "stripe", name: "Stripe" },
  { slug: "linear", name: "Linear" },
];

export const NAV_LINKS = [
  { key: "home", label: "Home", href: "#home" },
  { key: "about", label: "About", href: "#about" },
  { key: "services", label: "Services", href: "#services" },
  { key: "work", label: "Work", href: "#work" },
  { key: "process", label: "Process", href: "#process" },
  { key: "contact", label: "Contact", href: "#contact" },
];
